import router from "./index";
import { getToken } from "@/utils/auth";
import website from "@/config/website";
import store from "@/store";
import { MessageBox } from 'element-ui';
import { gotoReLogin, authGuardRedirect } from "@/utils/ncnp";
import { triggerPaasSilentSso } from "@/utils/paas";
import { buildAiLandingUrl } from "@/utils/ai-platform";

// 智算平台子菜单外链映射：菜单点击 → 路由守卫拦截 → token 校验 → 新窗口打开。
// '/zspt' 兜底旧地址(保留 redirect_target=default)，三个子菜单分别对应：
// 算力市场 / 一站式AI平台(computility/aistudio) / 大模型服务平台(maas,独立域名 + next=/dashboard)
// ai.ssc.net.cn landing 统一走 buildAiLandingUrl（与 /console/transit 中转复用同一构造器）。
const ZSPT_TARGETS = {
    '/zspt': () => buildAiLandingUrl('default'),
    '/zspt/computility': () => buildAiLandingUrl('computility'),
    '/zspt/aistudio': () => buildAiLandingUrl('aistudio'),
    '/zspt/maas': () => `https://maas.ssc.net.cn:8443/api/sso/landing?provider=csj-portal&token=${getToken()}&next=/dashboard`,
};

router.beforeEach(async (to, from, next) => {
    // 判断是否访问/infra或/portal路由
    if (to.meta.isUserAuthenticated && !getToken()) {
        // 外部入口页(meta.ncnpAuthEntry)自动发起 NCNP 授权码流程；其余按 loginSource 走 NCNP welcome / CA SSO
        authGuardRedirect(to);
        return;
    } else {
        // PaaS 静默 SSO：商品详情/订购页路由 meta.requirePaasSso=true 时
        // 在背景隐藏 iframe 触发一次 SSO（不阻断路由放行）
        if (to.meta && to.meta.requirePaasSso && getToken()) {
            triggerPaasSilentSso().catch(() => { /* 静默 SSO 失败不阻断业务 */ });
        }
        if (to.meta.title) {
            document.title = website.title + " - " + to.meta.title; // 动态设置标题
        } else {
            document.title = website.title;
        }
        if (to.path === "/portal") {
            // 未登录，检查URL中是否有code参数
            const code = to.query.code;
            if (code) {
                try {
                    // 有code参数，调用单点登录
                    await store.dispatch("user/ssoLogin", code);
                    next("/portal");
                } catch (error) {
                    console.error("单点登录失败:", error);
                    // 企业认证提示框已在user.js中处理，此处不做额外处理
                    next("/portal");
                }
            } else {
                next();
            }
        } else {
            // 非/infra路由，直接放行
            const zsptUrlBuilder = ZSPT_TARGETS[to.path];
            if (zsptUrlBuilder) {
                // 智算平台子菜单打开新窗口
                console.log("智算平台登录校验开始", to.path);
                store.dispatch("user/checkTokenValidity").then(result => {
                    console.log("智算平台登录校验结果:", result);
                    if (result.isValid) {
                        window.open(zsptUrlBuilder());
                        next(false);
                    } else {
                        // 智算平台登录失效，提示用户
                        MessageBox.confirm(
                            "登录状态已过期，是否重新登录？",
                            "提示",
                            {
                                confirmButtonText: "重新登录",
                                cancelButtonText: "返回",
                                type: "warning",
                            }
                        )
                            .then(() => {
                                // NCNP 用户走 welcome task_id=login，其余走 CA SSO
                                gotoReLogin();
                            })
                            .catch(() => {
                                // 跳转到首页
                                next(false);
                            });
                    }
                }).catch(error => {
                    console.error("智算平台登录失败:", error);
                    // 智算平台登录失败，提示用户
                });
            } else if (to.path === '/cspt') {
                // 算力平台打开新窗口
                console.log("超算平台登录校验开始");
                store.dispatch("user/checkTokenValidity").then(result => {
                    console.log("超算平台登录校验结果:", result);
                    if (result.isValid) {
                        window.open(
                            `https://xfinity.ssc.net.cn/csj/user/login.do?token=${getToken()}`
                        );
                        next(false);
                    } else {
                        // 算力平台登录失效，提示用户
                        MessageBox.confirm(
                            "登录状态已过期，是否重新登录？",
                            "提示",
                            {
                                confirmButtonText: "重新登录",
                                cancelButtonText: "返回",
                                type: "warning",
                            }
                        )
                            .then(() => {
                                // NCNP 用户走 welcome task_id=login，其余走 CA SSO
                                gotoReLogin();
                            })
                            .catch(() => {
                                // 跳转到首页
                                next(false);
                            });
                    }
                }).catch(error => {
                    console.error("超算平台登录失败:", error);
                    // 算力平台登录失败，提示用户
                });
            } else {
                next();
            }
        }
    }
});
